/** The Settings page's sections (spec §4.1) — pure so the nav and the tests
 *  cannot disagree. Icons are chosen in the screen, by id. */
export type SectionId = "brand" | "posting" | "autopilot" | "ai" | "security";

export const SECTIONS: readonly { id: SectionId; label: string }[] = [
  { id: "brand", label: "Brand" },
  { id: "posting", label: "Posting" },
  { id: "autopilot", label: "Autopilot" },
  { id: "ai", label: "AI & credits" },
  { id: "security", label: "Security" },
];

/** All five, always. Posting stays for a videos-only brand because VIDEO
 *  scheduling goes through Buffer too and the Buffer card is the only place
 *  to connect it — only the post-caption and CTA cards inside it gate on
 *  `postsEnabled` (the screen does that). Signature kept so callers and the
 *  test stay simple. */
export function visibleSections(_opts: { postsEnabled: boolean }): (typeof SECTIONS)[number][] {
  return [...SECTIONS];
}
